const config = {
    bankSearchWidget: {
        autoInit: true,
        initialHeight: '100%',
        height: 400,
        searchOnly: true,
        width: '100%',
    }
};

export default config;
